/*
 * @Author: 李文 
 * @Date: 2020-10-29 11:41:25 
 * @Last Modified by: 李文
 * @ 融煤发布--编辑图文--选择图文
 */

import React from 'react';
import {Modal, Tabs, Input, Table, Pagination, Button, message, Radio, Empty, Spin, TreeSelect} from 'antd';
import { getOriginalList,  getResourcePool, getPublishResource,  } from '../../../actions/originalManuscript';
import { getMaterialList, getManuscriptById } from '../../../actions/resourceList';
import './index.scss';
import Scrollbars from 'react-custom-scrollbars';
import * as actions from "../../../actions/originalManuscript";
import BaseComponent from "../../../base/BaseComponent";
import moment from "moment";

const { TabPane } = Tabs;
const { Search } = Input;


class SelectPictureOrArticle extends BaseComponent{
    constructor(props){
        super(props);
        this.state = {
            visible: false,  
            tabs: this.props.tabs,   //tabs的数据
            activeKey: this.props.tabs[0].id,  //当前选中的tab
            listData : [],  //列表数据
            total: 0, //总数
            pageSize: 6, //每页展示条数
            current: 1, //当前页
            selectItem: {}, //当前选中item
            keyWords: '', //查询关键字
            loading:false,
            mediaList:[],
            mediaCode:'',
        }
    }


    changeVisible = (visible) => {
        if(visible){
            this.getListData();
            // this.getOtherMedia()
        }
        this.setState({
            visible,
            activeKey:this.props.tabs[0].id,
            current:1,
            keyWords:""
        })
    }

    getColumns = () => {
        const columns = [
            {
              title: '文章标题',
              dataIndex: 'title',
              key: 'title',
              width: '40%',
              render: (text) => <span className="title" title={text}>{text}</span>
            },
            {
              title: '修改时间',
              dataIndex: 'updateTime',
              key: 'updateTime',
              width: '20%',
             render: (text) => <span className="date">{text?moment(text*1).format("YYYY-MM-DD HH:mm:ss"):"-"}</span>
            },
            {
              title: '创建人',
              dataIndex: 'creator',
              key: 'creator',
              width: '20%',
              render: (text) => <span style={{overflow: 'hidden',textOverflow:'ellipsis', width:'150px', display: "inline-block",
                  whiteSpace: "nowrap",
              }}>{text}</span>
            },
            {
                title: '操作',
                dataIndex: 'action',
                key: 'action',
                width: '10%',
                render : (text,record) => <Radio.Group onChange={this.changeItem} value={this.state.selectItem} className="select-item"><Radio value={record} size="large"></Radio></Radio.Group>
            }
        ];
        return columns 
    }

    handleCancel = () => {
        this.changeVisible(false);
    }

    changeItem = (e) => {
        console.log(e)
        this.setState({
            selectItem: e.target.value
        })
    }

    handleOk = () => {
        const { selectItem, activeKey } = this.state;
        if(Object.keys(selectItem).length === 0){
            message.error('请先选择关联图文！');
            return;
        }
        this.changeVisible(false);
        if(activeKey !== "4" && 1>2){
            getManuscriptById({type: 1, id: selectItem.id }, (res) => {
                if(res.state){
                    this.props.callBack && this.props.callBack(res.data)
                    this.setState({
                        selectItem: res.data
                    })
                }
            })
        } else {
            this.props.callBack && this.props.callBack(selectItem)
        }
    }

    renderContent = () => {
        const { listData, loading } = this.state
        return(
            loading ? <div style={{ height: '100%', display: 'flex', justifyContent:'center', alignItems: 'center'}}><Spin /></div> : (
                listData && listData.length === 0 ? <div style={{ height: '100%', display: 'flex', justifyContent:'center', alignItems: 'center'}}><Empty /></div> : 
                    <Scrollbars>
                        <Table
                            className="select-pic-table"
                            dataSource={listData}
                            columns={this.getColumns()}
                            rowKey={(record) => record.id}
                            locale={{ emptyText: '' }}
                            pagination={false} />
                    </Scrollbars>
            )
        )
    }

    handleTabChange = (key) => {
        this.setState({
            activeKey: key,
            current: 1,
            selectItem:{},
            keyWords: '',
            loading:false,
        }, () => {
            //切换tab,调查询接口
            this.getListData();
        })
    }

    getListData = () => {
        const { activeKey } = this.state;
        switch(activeKey){
            case '1' : this.getOriList(); break;

            case '2' : this.getConList(); break;

            case '3' : this.getOtherList(); break;

            case '4' : this.getMatList(); break;

            default:break;
        }

    }

    getParams = () => {
        const { keyWords, current, pageSize } = this.state;
        const { mediaCode } = this.props;
        return { start: current, size: pageSize, mediaCode: mediaCode, queryStr: keyWords}
    }

    //获取原创稿件 列表
    getOriList = () => {
        const params = this.getParams();
        this.setState({
            loading:true,
            selectItem: {},
            listData:[],
            total:0,
        }, () => {
            getOriginalList(params, res => {
                if(res.code === 0){
                    this.setState({
                        listData: res.data,
                        total: res.count,
                        loading:false
                    })
                }
            })
        })
    }

    //获取投稿稿件 列表
    getConList = () => {
        const params = this.getParams();
        this.setState({
            loading:true,
            selectItem: {},
            listData:[],
            total:0,
        }, () => {
            this.request({
                url: "/cm-sites-pms/story/v2/contributeList",
                body: {
                    mediaId: params.mediaCode,
                    keywords: params.queryStr,
                    page: params.start,
                    size: params.size,
                },
                callBack: (res) => {
                    if(res){
                        this.setState({
                            listData:res.data,
                            total: res.count,
                            loading: false
                        })
                    }
                }
            });

            // getResourcePool(params, res =>{
            //     if(res.code === 0){
            //         this.setState({
            //             listData:res.data,
            //             total: res.count,
            //             loading: false
            //         })
            //     }
            // })
        })
    };

    //获取 其他媒体稿件 列表
    getOtherList = () => {
        const params = this.getParams();
        params.mediaCode=this.state.mediaCode;
        this.setState({
            loading:true,
            selectItem: {},
            listData:[],
            total:0,
        }, () => {
            getPublishResource(params, res =>{
                if(res.code === 0){
                    this.setState({
                        listData:res.data,
                        total: res.count,
                        loading: false
                    })
                }
            })
        })
    }

    //获取其他媒体
    getOtherMedia() {
        let mediaCode = this.props.mediaCode;
        let mediaList = [{
            title: '网站',
            value: 'web',
            key: 'web',
            disabled: true,
            children: []
        },
            {
                title: '微信',
                value: 'wechat',
                key: 'wechat',
                disabled: true,
                children: []
            }];
        this.state.mediaCode = '';
        //获取全部媒体
        let otherAllList = [];
        window.loading&&window.loading.show();
        actions.getAllMedia(data => {
            if (data && data.length) {
                data.forEach(item => {
                    if (item.code !== mediaCode) {
                        console.log(item)
                        item.title = item.name;
                        item.key = item.code;
                        item.value = item.code;
                        item.type = item.type;
                        otherAllList.push(item);
                        if (item.type === 1) {
                            mediaList[0].children.push(item)
                        } else if (item.type === 2) {
                            console.log('微信')
                            mediaList[1].children.push(item)
                        }
                    }else{
                        this.state.startMediaType=item.type.toString();
                    }

                })
            }
            window.loading&&window.loading.hide();
            if (otherAllList.length) {
                for (let i=0;i<mediaList.length;i++){
                    let item =mediaList[i];
                    if(item.children.length>0){
                        this.state.mediaCode =  item.children[0] ? item.children[0].code : '';
                        this.state.mediaType = item.children[0].type.toString();
                        break;
                    }
                }
                /* this.state.mediaCode =  mediaList[0].children[0] ? mediaList[0].children[0].code : '';
                 this.state.mediaType = otherAllList[0].type.toString();*/
                console.log(this.state.mediaCode, this.state.mediaType);
              // this.getOtherList()
            }
            this.setState({mediaList})
        })

    }


    //获取 素材库稿件 列表
    getMatList =  () => {
        const { keyWords, current, pageSize } = this.state;
        const { mediaCode } = this.props;
        this.setState({
            loading: true,
            selectItem: {},
            listData:[],
            total:0,
        }, () => {
            this.request({
                url: "/cm-sites-pms/material/stuffList",
                body: {
                    mediaId: mediaCode,
                    keywords: keyWords,
                    page: current,
                    size: pageSize,
                },
                callBack: (res) => {
                    if(res){
                        let listData = [];
                        res.data && res.data.length > 0 && res.data.map((item) => listData.push({...item,changeDate:item.updateDate,} ));
                        this.setState({
                            listData,
                            total:res.count,
                            loading: false
                        })
                    }
                }
            });
            // getMaterialList({offset: current, count: pageSize, queryStr:keyWords, mediaCode: mediaCode}, (res) => {
            //    if(res.code === 0){
            //     let listData = [];
            //     res.data && res.data.length > 0 && res.data.map((item) => listData.push({...item,changeDate:item.updateDate,} ));
            //     this.setState({
            //         listData,
            //         total:res.count,
            //         loading: false
            //     })
            //    }
            // })
        })
    };



    onSearch = () => {
        //调用查询接口
        this.setState({
            current:1
        },() => {
            this.getListData();
        })
    }

    handlePagination = (page) => {
        this.setState({
            current: page
        }, () => {
            this.getListData();
        })
    } 


    render(){
        const { visible, tabs, activeKey, current, pageSize, total, keyWords, listData } = this.state;
        const { newSecondSelectColor } = this.props;
        return(
            <Modal
                className="select-pic-modal"
                width="60%"
                visible={visible}
                title="选择图文"
                destroyOnClose
                onCancel={this.handleCancel}
                footer={
                    listData.length > 0 ? 
                    <>
                     <Button onClick={this.handleCancel}>取消</Button>
                     <Button style={{ backgroundColor: newSecondSelectColor, borderColor: newSecondSelectColor}} type="primary" onClick={this.handleOk}>确定</Button>
                    </> : false
                    }
            >
                <div className="top">
                    <Tabs activeKey={activeKey} onChange={this.handleTabChange} className="top-tabs">
                        {
                            tabs.map((item) => (
                                <TabPane tab={item.title} key={item.id}></TabPane>
                            ))
                        }
                    </Tabs>
                    <style>
                                {`
            
           .top-tabs .ant-tabs-tab-active {
                color: ${newSecondSelectColor} !important;
            }
            .top-tabs .ant-tabs-nav .ant-tabs-tab:hover {
                color: ${newSecondSelectColor} !important;
            }
            .top-tabs .ant-tabs-ink-bar{
            background-color:${newSecondSelectColor} !important;
            }
                             `}</style>

                    {this.state.activeKey === '3' ?
                        <div style={{display: 'flex', lineHeight: '58px', position:'absolute',right:310}}>
                            <div><b>选择媒体</b></div>
                            <div style={{width: 180}}>
                                <TreeSelect
                                    /* showSearch*/
                                    style={{width: '100%', paddingLeft: 10, fontSize: 16, color: '#a4adc8'}}
                                    value={this.state.mediaCode}
                                    dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                                    placeholder="请选择"
                                    treeDefaultExpandAll
                                    treeData={this.state.mediaList}
                                    onChange={(value, title, item) => {
                                        //  console.log(title,item)
                                        let type = item.triggerNode.props.type.toString();
                                       // this.state.mediaType = type;
                                       // this.state.selectUpOrDownType=type;
                                        this.state.mediaCode = value;
                                        this.state.current = 1;
                                        this.state.pageSize = 10;
                                        this.setState({});
                                        this.getOtherList();
                                    }
                                    }
                                />
                            </div>

                        </div> : null}
                    <div className="search">
                        <Search placeholder="请输入搜索内容" value={keyWords} onChange={(e) => this.setState({ keyWords: e.target.value})} onSearch={this.onSearch}  />
                    </div>
                </div>
                <div className="content">
                    {this.renderContent()}
                </div>
               
                    <div className="footer">
                        {
                            listData.length > 0 ? <Pagination current={current} pageSize={pageSize} total={total} onChange={this.handlePagination} /> : ''
                        }
                    
                </div> 
                
            </Modal>
        )
    }
}

SelectPictureOrArticle.defaultProps = {
    tabs: [
        // {
        //     id: '1',
        //     title: '原创稿件'
        // },
        {
            id: '2',
            title: '投稿稿件'
        },
        // {
        //     id: '3',
        //     title: '其他媒体稿件'
        // },
        {
            id: '4',
            title: '素材库稿件'
        }
    ],
    newSecondSelectColor: '#0050B3'
}

export default SelectPictureOrArticle